import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FLAG_API } from './constants';
import { XMLParser } from 'fast-xml-parser';

import high_hazard_flag from 'images/icons/high_hazard_flag.svg';
import water_closed_flag from 'images/icons/water_closed_flag.svg';
import med_hazard_flag from 'images/icons/med_hazard_flag.svg';
import low_hazard_flag from 'images/icons/low_hazard_flag.svg';
import marine_life_flag from 'images/icons/marine_life_flag.svg';

const flags = {
	red: high_hazard_flag,
	double: water_closed_flag,
	'double red': water_closed_flag,
	yellow: med_hazard_flag,
	green: low_hazard_flag,
	purple: marine_life_flag,
}

export const flagApi = createApi({
	reducerPath: 'flagApi',
	baseQuery: fetchBaseQuery({
		baseUrl: FLAG_API,
		responseHandler: (response) => response.text(),
	}),
	endpoints: (build) => ({
		getFlag: build.query({
			query: () => ``,
			responseHandler: (response) => response.text(),
			transformResponse: (response) => {
				const parser = new XMLParser();
				const xml = parser.parse(response);
				const flagColor = xml.beach?.flagcolor;
				const condition = xml.beach?.condition;
				let secondaryFlagColor;
				let secondaryCondition;
				if (xml.beach?.marinepests?.status === 1) {
					secondaryFlagColor = xml.beach.marinepests.flagcolor;
					secondaryCondition = xml.beach.marinepests.condition;
				}
				return {
					flagColor,
					flag: flags[flagColor],
					condition,
					longCondition: xml.beach?.conditionlong,
					definitions: xml.beach?.definitions,
					secondaryFlagColor,
					secondaryFlag: flags[secondaryFlagColor],
					secondaryCondition,
				}
			}
		}),
	}),
});

export const { useGetFlagQuery } = flagApi;